import NiceModal from '@ebay/nice-modal-react'

import { DecommissionTemplate } from './DecommissionModal'

const DecommissionTemplateModal = NiceModal.create(DecommissionTemplate)

export const showDecommissionModal = (code: string) =>
  NiceModal.show(DecommissionTemplateModal, { code })
